import { createGlobalState } from '@vueuse/core'
import { computed, shallowRef } from 'vue'

export const useGlobalState = createGlobalState(() => {
  // state
  const dialog = shallowRef({
    'location1-th': false,
    'location2-th': false,
    'location3-th': false,
    'location4-th': false,
    'location5-th': false,
    'location6-th': false,
    'location7-th': false,
    'location1-en': false,
    'location2-en': false,
    'location3-en': false,
    'location4-en': false,
    'location5-en': false,
    'location6-en': false,
    'location7-en': false,
  } as any)

  // getters

  // actions
  function updateDialog(name: any, isOpened: boolean) {
    dialog.value[name] = isOpened
  }

  return { dialog, updateDialog }
})
